import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import NavigatorMain from '../NavigatorMain';
class H5page extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  componentDidMount(){
    document.getElementById("viewDiv").innerHTML = `<object type="text/html" data="${this.props.location.state.urlString}" width="100%" height="100%"></object>`
  }
  render(){
    return (
        <div className="container" >
          <NavigatorMain>
            <div className="header black">
              <div onClick={hashHistory.goBack}><span className="headerLeftBtn"></span></div>
              <div>{this.props.location.state.title}</div>
              <div></div>
            </div>
          </NavigatorMain>
          <div className='content' id='viewDiv'>
            
          </div>
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
   
  }
}
export default connect(mapStateToProps)(H5page);



// WEBPACK FOOTER //
// ./src/components/product/H5page.js